import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import  VueResource  from 'vue-resource'
import VueDirectiveWindow from 'vue-directive-window'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import axios from 'axios'
import robotApi from './api'
import request from "./request"

import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

// 引入 barba.js
import barba from '@barba/core'

//全局注册，使用方法为:this.$xxx
Vue.prototype.$axios = axios
Vue.prototype.$robotApi = robotApi
Vue.prototype.$request = request

//blocky配置
Vue.config.productionTip = false;
Vue.config.ignoredElements = ['field','block','category','xml','mutation','value','sep']

//Vue脚手架初始化
Vue.use(VueDirectiveWindow);
Vue.use(VueResource);
Vue.use(ElementUI);

Vue.use(VideoPlayer)

// 创建 Vue 实例
const app = new Vue({
  router,
  vuetify,
  render: h => h(App),
  data:{
    return:{
      messageb:'',
    }
  },
  mounted() {
    // 在 Vue 实例挂载后初始化 barba.js
    this.initBarba();
  },
  methods: {
    initBarba() {
      // 初始化 barba.js，使用更简单的配置
      barba.init({
        // 禁用 barba 的默认路由处理，因为我们使用 vue-router
        prevent: ({ el }) => {
          return el.classList && el.classList.contains('barba-prevent');
        },
        // 简单的转场动画
        transitions: [
          {
            name: 'simple-transition',
            leave(data) {
              return new Promise(resolve => {
                const container = data.current.container;
                if (container) {
                  container.style.transition = 'all 0.5s ease-in-out';
                  container.style.opacity = '0';
                  container.style.transform = 'scale(0.9)';
                  setTimeout(resolve, 500);
                } else {
                  resolve();
                }
              });
            },
            enter(data) {
              return new Promise(resolve => {
                const container = data.next.container;
                if (container) {
                  container.style.opacity = '0';
                  container.style.transform = 'scale(1.1)';
                  
                  setTimeout(() => {
                    container.style.transition = 'all 0.5s ease-in-out';
                    container.style.opacity = '1';
                    container.style.transform = 'scale(1)';
                    setTimeout(resolve, 500);
                  }, 50);
                } else {
                  resolve();
                }
              });
            }
          }
        ]
      });

      // 监听路由变化，手动触发页面动画
      this.$router.beforeEach((to, from, next) => {
        // 为页面切换添加动画效果
        this.addPageTransition(to, from);
        next();
      });
    },
    addPageTransition(to, from) {
      // 获取页面容器
      const container = document.querySelector('.page-container');
      if (!container) return;

      // 根据路由设置不同的动画效果
      if (from.path === '/login' && to.path !== '/login') {
        // 从登录页跳转的特殊动画
        this.playLoginExitAnimation(container);
      } else if (to.path === '/login') {
        // 进入登录页的动画
        this.playLoginEnterAnimation(container);
      } else if (to.path === '/cockpit1') {
        // 进入 cockpit1 页面的动画
        this.playCockpitEnterAnimation(container);
      } else if (from.path === '/cockpit1') {
        // 从 cockpit1 离开的动画
        this.playCockpitExitAnimation(container);
      } else if (to.path.includes('/coursedetail')) {
        // 进入课程详情页的动画
        this.playCourseDetailEnterAnimation(container);
      } else if (to.path.includes('/Game/scratch')) {
        // 进入编程页面的动画
        this.playCodingEnterAnimation(container);
      } else {
        // 普通页面切换动画
        this.playNormalTransition(container);
      }
    },
    playLoginExitAnimation(container) {
      // 登录页离开动画 - 开心弹跳效果
      container.style.transition = 'all 0.2s cubic-bezier(0.68, -0.55, 0.27, 1.55)';
      container.style.transform = 'scale(0.8) rotate(-15deg)';
      container.style.opacity = '0';
      container.style.filter = 'blur(8px) brightness(1.3)';
      
      setTimeout(() => {
        container.style.transform = 'scale(1) rotate(0deg)';
        container.style.opacity = '1';
        container.style.filter = 'blur(0) brightness(1)';
      }, 600);
    },
    playLoginEnterAnimation(container) {
      // 登录页进入动画 - 开心弹跳效果
      container.style.opacity = '0';
      container.style.transform = 'scale(1.2) rotate(15deg)';
      container.style.filter = 'blur(8px) brightness(1.3)';
      
      setTimeout(() => {
        container.style.transition = 'all 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55)';
        container.style.opacity = '1';
        container.style.transform = 'scale(1) rotate(0deg)';
        container.style.filter = 'blur(0) brightness(1)';
        
        // 添加额外的弹跳效果
        setTimeout(() => {
          container.style.transform = 'scale(1.05)';
          setTimeout(() => {
            container.style.transform = 'scale(1)';
          }, 150);
        }, 100);
      }, 50);
    },
    playCockpitEnterAnimation(container) {
      // cockpit1 页面进入动画 - 科技感弹跳效果
      container.style.opacity = '0';
      container.style.transform = 'scale(1.3) translateY(-50px)';
      container.style.filter = 'blur(10px) brightness(1.5)';
      
      setTimeout(() => {
        container.style.transition = 'all 0.4s cubic-bezier(0.68, -0.55, 0.27, 1.55)';
        container.style.opacity = '1';
        container.style.transform = 'scale(1) translateY(0)';
        container.style.filter = 'blur(0) brightness(1)';
        
        // 添加科技感的弹跳效果
        setTimeout(() => {
          container.style.transform = 'scale(1.02) translateY(-5px)';
          setTimeout(() => {
            container.style.transform = 'scale(1) translateY(0)';
          }, 200);
        }, 150);
      }, 50);
    },
    playCockpitExitAnimation(container) {
      // cockpit1 页面离开动画 - 科技感旋转效果
      container.style.transition = 'all 0.2s cubic-bezier(0.68, -0.55, 0.27, 1.55)';
      container.style.transform = 'scale(0.9) rotate(20deg) translateY(30px)';
      container.style.opacity = '0';
      container.style.filter = 'blur(12px) brightness(1.4)';
      
      setTimeout(() => {
        container.style.transform = 'scale(1) rotate(0deg) translateY(0)';
        container.style.opacity = '1';
        container.style.filter = 'blur(0) brightness(1)';
      }, 700);
    },
    playCourseDetailEnterAnimation(container) {
      // 课程详情页进入动画 - 书本翻页效果
      container.style.opacity = '0';
      container.style.transform = 'scale(1.4) rotateY(45deg)';
      container.style.filter = 'blur(15px) brightness(1.6)';
      
      setTimeout(() => {
        container.style.transition = 'all 1s cubic-bezier(0.68, -0.55, 0.27, 1.55)';
        container.style.opacity = '1';
        container.style.transform = 'scale(1) rotateY(0deg)';
        container.style.filter = 'blur(0) brightness(1)';
        
        // 添加书本翻页的弹跳效果
        setTimeout(() => {
          container.style.transform = 'scale(1.03) rotateY(5deg)';
          setTimeout(() => {
            container.style.transform = 'scale(1) rotateY(0deg)';
          }, 250);
        }, 200);
      }, 50);
    },
    playCodingEnterAnimation(container) {
      // 编程页面进入动画 - 代码编译效果
      container.style.opacity = '0';
      container.style.transform = 'scale(1.5) translateY(-80px)';
      container.style.filter = 'blur(20px) brightness(2)';
      
      setTimeout(() => {
        container.style.transition = 'all 0.4s cubic-bezier(0.68, -0.55, 0.27, 1.55)';
        container.style.opacity = '1';
        container.style.transform = 'scale(1) translateY(0)';
        container.style.filter = 'blur(0) brightness(1)';
        
        // 添加代码编译的闪烁效果
        setTimeout(() => {
          container.style.filter = 'brightness(1.2)';
          setTimeout(() => {
            container.style.filter = 'brightness(1)';
          }, 100);
        }, 300);
      }, 50);
    },
    playNormalTransition(container) {
      // 普通页面切换动画
      container.style.transition = 'all 0.1s ease-in-out';
      container.style.opacity = '0.8';
      container.style.transform = 'scale(0.95)';
      
      setTimeout(() => {
        container.style.opacity = '1';
        container.style.transform = 'scale(1)';
      }, 200);
    }
  }
}).$mount('#app')


